
import { ImageGalleryScreenNavigationProps, ImageGalleryProps } from "./types"
import React from "react"
import ImageGallery from "./image-gallery-screen"
import { PageRoot } from "~screens/page-root"

const ImageGalleryScreen: React.FC<ImageGalleryScreenNavigationProps> = ({ route }) => {
  const params = (route.params ?? {}) as ImageGalleryProps

  return (
    <PageRoot>
      <ImageGallery images={params.images ?? []} index={params.index ?? 0} />
    </PageRoot>
  )
}

export default ImageGalleryScreen
